import { useClasses } from "@xo-union/react-css-modules";
import { Body2 } from "@xo-union/tk-ui-typography";
import { useUniqueID } from "@xo-union/react-unique-id";
import { renderLabel, getProgressRenderData } from "../../utils/index.js";
import styles from "./styles.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? progress * 100 : _ref$value,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    valueText = _ref.valueText,
    label = _ref.label,
    color = _ref.color,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'progressbar' : _ref$role,
    classesProp = _ref.classes,
    ariaValueText = _ref['aria-valuetext'];
  var classes = useClasses(styles, classesProp);
  var labelId = useUniqueID();
  var _getProgressRenderDat = getProgressRenderData(value, min, max, valueText),
    percent = _getProgressRenderDat.percent,
    valueData = _getProgressRenderDat.valueData;
  var labelToRender = renderLabel(label, value, percent, max);
  var style = {
    '--P_value-text-width': valueData.width,
    '--P_thumb-width': "".concat(percent, "%"),
    '--P_thumb-color': color
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classes['progress-bar'],
    role: role,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": valueData.text,
    "aria-valuetext": ariaValueText || "".concat(valueData.text).concat(valueData.suffix),
    "aria-labelledby": labelToRender ? labelId : undefined,
    style: style,
    children: [/*#__PURE__*/_jsxs("div", {
      className: classes['bar-container'],
      children: [/*#__PURE__*/_jsx("div", {
        className: classes.bar,
        children: /*#__PURE__*/_jsx("div", {
          className: classes.track,
          children: /*#__PURE__*/_jsx("div", {
            className: classes.thumb
          })
        })
      }), valueText && /*#__PURE__*/_jsxs(Body2, {
        className: classes['value-text'],
        children: [valueData.text, valueData.suffix]
      })]
    }), label && /*#__PURE__*/_jsx(Body2, {
      id: labelId,
      children: labelToRender
    })]
  });
};
export default ProgressBar;